import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import classNames from "classnames";
import { useDispatch } from "react-redux";
// import appUrl from "../../../config/appUrl";
import { Image } from "primereact/image";
import appUrl from "../../../config/appUrl";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";

const AddEditExemptedVehicle = ({
  onHide,
  getExemptedVehicles,
  addEditVehicleType,
  exemptedVehicleId,
}) => {
  // const [iconEdit, setIconEdit] = useState("");
  const [siteList, setSiteList] = useState([]);


  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();

      setSiteList(data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getExemptedById = async () => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}exempted/${exemptedVehicleId}`
      );
      const keyData = await response.json();
      Object.keys(keyData?.data).forEach((key) => {
        if (formik.initialValues.hasOwnProperty(key)) {
          formik.setFieldValue(key, keyData?.data[key]);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if(addEditVehicleType){
    getExemptedById()
  }
    getSiteList()
  }, [])
  
  console.log("site List is", siteList)

  const validationSchema = Yup.object().shape({
    // vehicleRegNumber: Yup.string()
    //   .required("This field is required.")
    //   .max(20, "max limit is 20"),
       qr: Yup.string()
      .required("This field is required.")
      .max(20, "max limit is 20"),
    // icon: Yup.mixed().required("This field is required."),
    // site: Yup.string().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      vehicleRegNumber: "",
       qr: "",
      // fee: "",
    },

    onSubmit: async (data) => {
      if (addEditVehicleType) {
        try {
          console.log("data is", data);
          const response = await fetch(`${appUrl.BASE_URL}exempted/${exemptedVehicleId}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
    
          if (response.ok) { // Simplifies checking for 200 or 201 status
            toast.success("Edited successfully");
            await getExemptedVehicles();
          } else {
            const errorData = await response.json(); // Extract error message from response
            toast.error(errorData.msg || "An error occurred");
          }
          onHide();
        } catch (error) {
          toast.error(error.message || "Network error");
          console.error(error);
        }
      } else {
        try {
          const response = await fetch(`${appUrl.BASE_URL}exempted`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
    
          if (response.ok) {
            toast.success("Vehicle exempted successfully");
            await getExemptedVehicles();
          } else {
            const errorData = await response.json();
            toast.error(errorData.msg || "An error occurred");
          }
          onHide();
        } catch (error) {
          toast.error(error.message || "Network error");
          console.error(error);
        }
      }
    },
    
  });

  const isFormFieldValid = (vehicleRegNumber) =>
    !!(formik.touched[vehicleRegNumber] && formik.errors[vehicleRegNumber]);
  const getFormErrorMessage = (vehicleRegNumber) => {
    return (
      isFormFieldValid(vehicleRegNumber) && (
        <small className="p-error">{formik.errors[vehicleRegNumber]}</small>
      )
    );
  };


  return (
    <div>
      <h5>
        {addEditVehicleType ? "Edit Exempted Vehicle" : "Add Exempted Vehicle"}
      </h5>
      <div className="brdr__top">
        <form onSubmit={formik.handleSubmit}>
          <div className="card">
            <div className="p-fluid formgrid grid">
              <div className="field col-12 md:col-6">
                <label style={{ fontWeight: "bold" }}>
                  {" "}
                  Vehicle Reg Number{" "}
                </label>
               
                <InputText
                  id="vehicleRegNumber"
                  name="vehicleRegNumber"
                  // keyfilter={/^[^<>*!0123456789]+$/}
                  value={formik.values.vehicleRegNumber}
                  onChange={(event) => {
                    const inputValue = event.target.value;
                    if (inputValue.length <= 20) {
                      formik.handleChange(event);
                    }
                  }}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("vehicleRegNumber") },
                    "TextArea__Round"
                  )}
                  type="text"
                />
                {getFormErrorMessage("vehicleRegNumber")}
              </div>
              <div className="field col-12 md:col-6">
                <label style={{ fontWeight: "bold" }}>
                  {" "}
                  QR{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="qr"
                  name="qr"
                  // keyfilter={/^[^<>*!0123456789]+$/}
                  value={formik.values.qr}
                  onChange={(event) => {
                    const inputValue = event.target.value;
                    if (inputValue.length <= 20) {
                      formik.handleChange(event);
                    }
                  }}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("qr") },
                    "TextArea__Round"
                  )}
                  type="text"
                />
                {getFormErrorMessage("qr")}
              </div>

              <br />

              <div className="col-12 text-center mt-6 flex justify-content-end">
                <Button
                  label="Cancel"
                  className="Cancel__button mr-3"
                  type="button"
                  onClick={onHide}
                />
                <Button
                  type="submit"
                  className="Save__Button"
                  label={addEditVehicleType ? "Update" : "Save"}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditExemptedVehicle;
